import type { RouteRecordRaw } from 'vue-router';

import { XomProRouterView } from '@inn/components';

export const asyncRoutes: RouteRecordRaw[] = [
  {
    path: '/member',
    redirect: '/member/message',
    name: 'XomUserCenter',
    meta: { page: 'manage', title: '用户中心', safe: true },
    component: () => import('@/pages/manages/index.vue'),
    children: [
      {
        name: 'XomMessage',
        path: '/member/message',
        meta: { title: '消息中心', order: 10, icon: 'MessageOutlined', safe: true },
        component: XomProRouterView,
        redirect: '/member/message/platform',
        children: [
          {
            name: 'MemberMessagePlatform',
            path: '/member/message/platform',
            meta: { title: '平台消息', order: 10, safe: true },
            component: () => import('@/modules/member/message/platform/index.vue'),
          },
          {
            name: 'MemberMessageBusiness',
            path: '/member/message/business',
            meta: { title: '业务消息', order: 20, safe: true },
            component: () => import('@/modules/member/message/business/index.vue'),
          },
        ],
      },
      {
        name: 'MemberSecurity',
        path: '/member/security',
        // page: 'home' → 仅保留顶栏，不渲染左侧菜单与平台标签栏（账号安全中心为独立自助页，页内 a-tabs 切换视图，不走路由）
        // 权限点管控：单页面权限点（key=MemberSecurity，path=/security），接口资源全部绑定到该权限点，统一放入「默认权限」
        // 配置清单见 modules/member/security/PERMISSIONS.md
        meta: { page: 'home', title: '账号安全', order: 20, icon: 'SafetyOutlined' },
        component: () => import('@/modules/member/security/index.vue'),
      },
      {
        name: 'MemberHelp',
        path: '/member/help',
        meta: { title: '帮助与反馈', order: 20, icon: 'QuestionCircleOutlined', safe: true },
        component: () => import('@/modules/member/help/index.vue'),
      },
    ],
  },
  {
    path: '/bench',
    redirect: '/bench/index',
    name: 'XomBench',
    meta: { page: 'home', title: '工作台', safe: true },
    component: () => import('@/pages/manages/index.vue'),
    children: [
      {
        name: 'XomBenchHome',
        path: '/bench/index',
        meta: { title: '工作台', order: 10, icon: 'MessageOutlined', safe: true },
        component: XomProRouterView,
      },
    ],
  },
];
